export default __webpack_public_path__ + "static/media/movie.825fa04e.png";